module.exports = __webpack_public_path__ + "img/辐射省份.d549a250.svg";